import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { rgba, position, size } from 'polished';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import _ from 'lodash';
import fp from 'lodash/fp';
import { media } from '@deerplusofficial/pos-helper';
import { withClient, withClientProvider } from '@deerplusofficial/pos-hoc';
import withChannelGuard from '../../assist/withChannelGuard';
import { withQueryChannel } from '../../model/Queries';
import PosList from './PosList';
import Topbar from './Topbar';
import LoginForm from './LoginForm';
import { PageTitle } from '../../components';
import cover from './images/login-cover.jpg';

const Container = styled.div`
  ${position('absolute', '0', null, null, '0')};
  ${size('100%', '100%')};
  display: flex;
  overflow: hidden;
  background: url(${cover}) 50% 50% / cover no-repeat;
`;

const Sidebar = styled.div`
  padding: 24px 30px;
  position: relative;
  overflow: auto;
  width: 100%;
  background-color: #27272a;
  color: #ffffff;
  ${media(
    'tablet',
    css`
      width: 320px;
      box-shadow: 3px 0 5px ${rgba('#000000', 0.3)};
    `
  )};
`;

class Login extends Component {
  static propTypes = {
    client: PropTypes.shape({}),
  };

  static defaultProps = {
    client: {},
  };

  get isAuthorized() {
    return _.size(this.props.client.token) > 0;
  }

  renderTransition = (key, component) => (
    <CSSTransition key={key} timeout={400} classNames="fade">
      {component}
    </CSSTransition>
  );

  render() {
    return (
      <Container>
        <PageTitle />
        <Sidebar>
          <Topbar withLogout={this.isAuthorized} />
          <TransitionGroup>
            {this.isAuthorized
              ? this.renderTransition('pos-list', <PosList />)
              : this.renderTransition('login-form', <LoginForm />)}
          </TransitionGroup>
        </Sidebar>
      </Container>
    );
  }
}

export default fp.compose(
  withClientProvider(),
  withClient(),
  withChannelGuard(),
  withQueryChannel()
)(Login);



// WEBPACK FOOTER //
// ./src/pages/Login/Login.js